const styles = ({ COLORS, FONT_SIZES }) => ({
  title: {
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    ...FONT_SIZES.HEADING_EXTRA_LARGE.STYLE,
    margin: '0',
    textAlign: 'center'
  }
})

export default styles
